import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

import { toRefs } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggleClick'],
  setup(__props, {
    emit: __emit
  }) {
    const prop = __props;
    const {
      isActive
    } = toRefs(prop);
    const emit = __emit;
    function toggleClick() {
      emit('toggleClick');
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        style: {
          "padding": "0 15px"
        },
        onClick: toggleClick
      }, [(_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass([{
          'is-active': _unref(isActive)
        }, "hamburger"]),
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg",
        width: "64",
        height: "64"
      }, _cache[0] || (_cache[0] = [_createElementVNode("path", {
        d: "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
      }, null, -1)]), 2))]);
    };
  }
});